import { createContext, useContext, useEffect, useReducer } from "react";
import { ErrorFaultStateModel, initialErrorFaultState } from "models/ErrorFaultState";
import { errorFaultReducer } from "./ErrorFaultReducer";
import { AddErrorFault, ErrorFault } from "models/ErrorFault";
import { ErrorToastContainer } from "components/ErrorToastContainer";

type Props = {
    children: React.ReactNode;
};

const ErrorFaultContext = createContext<{stateErrorFault: ErrorFaultStateModel}>({stateErrorFault: initialErrorFaultState});

const ErrorFaultProvider = ({ children }: Props) => {

  const [stateErrorFault, dispatch] = useReducer(errorFaultReducer, initialErrorFaultState)
  stateErrorFault.addError = (errorFault: ErrorFault): void => {
    dispatch({ type: "add_error", payload: errorFault });
  };
  
  stateErrorFault.removeError = (errorFault: ErrorFault): void => {
    dispatch({ type: "remove_error", payload: errorFault });
  }

  

  useEffect(() => {

    let checkForError = setInterval(() => {
      const storage =JSON.parse(localStorage.getItem('errorfaultdata') || '{}');
      if(!!Object.keys(storage).length) {
        Object.keys(storage).forEach((key) => {
            const safeErrorParse: AddErrorFault = storage[key];
            const create:ErrorFault = {
              id: safeErrorParse.id !== null ? safeErrorParse.id : Math.floor(Math.random() * 100),
              message: safeErrorParse.message !== null ? safeErrorParse.message : "Error message unknown",
              title: safeErrorParse.title !== null ? safeErrorParse.title : "Error title unknown",
              type: safeErrorParse.type !== null ? safeErrorParse.type : "alert",
              error: safeErrorParse.error
            }
            dispatch({ type: "add_error", payload: create });
        })
        localStorage.removeItem('errorfaultdata');
      }
    }, 1000);

    return () => {
        clearInterval(checkForError);
    };
  }, [])

  return (<ErrorFaultContext.Provider value={{stateErrorFault}}>{children}<ErrorToastContainer toasts={stateErrorFault.errorFaults} /></ErrorFaultContext.Provider>);
};

export default ErrorFaultProvider;

export const ErrorFaultState = () =>{
    return useContext(ErrorFaultContext);
}